export const RECAPTCHA_SITE_TOKEN = "6LcMmIQUAAAAAHN5QOdn5PW5EigJkRDdgDAfEZMz";
